import { Box, Typography } from "./Mui";

export function Footer() {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        flexDirection: "column",
      }}
    >
      <Typography sx={{ color: "#28BF5B", fontSize: "50px", fontWeight: 800 }}>
        The Future is Ready to Unfold
      </Typography>

      <Typography
        sx={{ fontSize: "20px", color: "text.secondary", margin: "10px 0 0 0" }}
      >
        Ushering in a New Era of Decentralized Sharing.
      </Typography>

      <Box
        sx={{
          margin: "45px 0 0 0",
          display: "flex",
          gap: "20px 40px",
          "@media(max-width: 640px)": {
            flexWrap: "wrap",
            justifyContent: "center",
          },
        }}
      >
        <a href="https://x.com/Poki_Wallet" target="_blank" rel="noreferrer">
          <img src="/images/x.svg" alt="" />
        </a>

        <a
          href="https://oc.app/community/peafy-yaaaa-aaaac-aowna-cai/channel/1166547397/?ref=llrey-cqaaa-aaaac-ao23a-cai"
          target="_blank"
          rel="noreferrer"
        >
          <img src="/images/openchat.svg" alt="" />
        </a>

        <a
          href="https://github.com/Poki-labs/interface"
          target="_black"
          rel="noreferrer"
        >
          <img src="/images/github.svg" alt="" />
        </a>

        <a
          href="https://pokiwallet.gitbook.io/pokiwallet"
          target="_blank"
          rel="noreferrer"
        >
          <img src="/images/book.svg" alt="" />
        </a>

        <a href="mailto:service@pokiwallet.com">
          <img src="/images/email.svg" alt="" />
        </a>
      </Box>
    </Box>
  );
}
